import React, { createContext, useState } from 'react'

import Field from './Field'
import { Container, Form } from './styles'
import { FormattedMessage } from 'react-intl'
import DropzoneImageInput from '~/components/DropzoneImageInput'

export const ImagesFormContext = createContext()

function ImagesForm({ formik }) {
  const [editableFields, setEditableFields] = useState({})

  const handleSwitchChange = switchId => {
    setEditableFields(prevState => ({
      ...prevState,
      [switchId]: !editableFields[switchId],
    }))
  }

  const defaultProps = {
    onSwitchChange: handleSwitchChange,
    editableFields: editableFields,
    controller: formik,
    onToggleOff: name => {
      formik.setFieldValue(name, {})
    }
  }

  return (
    <Container>
      <Form>
        <ImagesFormContext.Provider value={{editableFields}}>
          <Field
            {...defaultProps}
            name="images.logo"
            label="Logo"
            render={DropzoneImageInput}
            type="file"
            helperText={
              <FormattedMessage id="The minimum is 250px by 250px (recommended 720px by 720px). Max size 5mb JPG or PNG." />
            }
            onChange={files => formik.setFieldValue('images.logo', files)}
          />
          <Field
            {...defaultProps}
            name="images.cover"
            label="Cover"
            render={DropzoneImageInput}
            type="file"
            helperText={
              <FormattedMessage id="Recommended aspect ratio 16:9 (1280px by 720px or 1920px by 1080px). Min size 1mb and Max size 5mb JPG or PNG." />
            }
            onChange={files => formik.setFieldValue('images.cover', files)}
          />
          <Field
            {...defaultProps}
            name="images.interior"
            label="Interior"
            render={DropzoneImageInput}
            type="file"
            multiple
            helperText={
              <FormattedMessage id="Recommended aspect ratio 16:9 (1280px by 720px or 1920px by 1080px). Min size 1mb and Max size 5mb JPG or PNG." />
            }
            onChange={files => formik.setFieldValue('images.interior', files)}
          />
          <Field
            {...defaultProps}
            name="images.exterior"
            label="Exterior"
            render={DropzoneImageInput}
            type="file"
            multiple
            helperText={
              <FormattedMessage id="Recommended aspect ratio 16:9 (1280px by 720px or 1920px by 1080px). Min size 1mb and Max size 5mb JPG or PNG." />
            }
            onChange={files => formik.setFieldValue('images.exterior', files)}
          />
          <Field
            {...defaultProps}
            name="images.additional"
            label="Additional"
            render={DropzoneImageInput}
            type="file"
            multiple
            helperText={
              <FormattedMessage id="Recommended aspect ratio 16:9 (1280px by 720px or 1920px by 1080px). Min size 1mb and Max size 5mb JPG or PNG." />
            }
            onChange={files => formik.setFieldValue('images.additional', files)}
          />
        </ImagesFormContext.Provider>
      </Form>
    </Container>
  )
}

export default ImagesForm
